export const removeObject = (list: any, obj: any) => {
  let tab: any[] = [];
  if (list?.length && obj.id) {
    tab = [...list];
    const index = tab.findIndex((t) => t?.id == obj.id);
    if (index != -1) {
      tab.splice(index, 1);
    }
  }
  return tab;
};

export const addOrUpdateObject = (list: any[], obj: any) => {
  if (!obj) return list || [];

  const tab = list ? [...list] : [];
  const fullName = `${obj?.firstname?.trim()} ${obj?.name?.trim()}`;

  // Trouver l'index du membre existant basé sur `id` ou `nom complet`
  const index = tab.findIndex(
    (t) =>
      t?.id === obj.id ||
      `${t?.firstname?.trim()} ${t?.name?.trim()}` === fullName,
  );

  if (index === -1) {
    // Ajouter un nouvel objet si non trouvé
    tab.push(obj);
  } else {
    // Mettre à jour l'objet existant
    tab[index] = obj;
  }

  return tab;
};
